import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Brain, Users, Clock } from "lucide-react";

const CSWvsCram = () => {
  return (
    <ComparisonPageTemplate
      platformName="Cram"
      platformUrl="https://www.cram.com"
      seoDescription="Compare CSW and Cram flashcard platforms. Discover why CSW offers better analytics and collaborative study features."
      seoKeywords="CSW vs Cram, Cram alternative, free flashcard maker, study flashcards online"
      canonicalUrl="https://csw.live/flash-cards/csw-vs-cram/"
      heroDescription="Looking for more than basic flashcards? CSW offers advanced features, collaborative study, and gamified learning."
      alternativeDescription="While Cram offers quick deck creation, CSW provides a richer learning experience with analytics and collaboration."
      background="Cram is a flashcard platform where creating decks is quick and straightforward with memorize and cram study modes."
      pros={[
        { text: "Quick and easy deck creation" },
        { text: "Memorize and cram study modes" },
        { text: "Free on mobile and desktop" }
      ]}
      cons={[
        { text: "Limited customization options" },
        { text: "No advanced analytics" },
        { text: "No spaced-repetition system" }
      ]}
      cswFeatures={[
        { text: "Advanced Analytics", available: true },
        { text: "Collaborative Study", available: true },
        { text: "Modern Interface", available: true },
        { text: "Free Access", available: true }
      ]}
      competitorFeatures={[
        { text: "Advanced Analytics", available: false },
        { text: "Collaborative Study", available: false },
        { text: "Modern Interface", available: false },
        { text: "Free Access", available: true }
      ]}
      benefits={[
        { icon: Brain, title: "Smart Learning", description: "Track your progress with advanced analytics." },
        { icon: Users, title: "Social Study", description: "Study with friends in collaborative sessions." },
        { icon: Clock, title: "Modern Experience", description: "Enjoy a clean, modern interface." }
      ]}
      forStudentsText="CSW goes beyond Cram's basic flashcards with analytics, collaboration, and gamification."
      pricingText="Both platforms offer free access, but CSW provides significantly more features."
      competitorPrice="Free"
    />
  );
};

export default CSWvsCram;
